<script>
  import PrivacyCommon from "./PrivacyCommon.svelte";
  import Privacy23 from "./Privacy23.svelte";
  import Privacy27Q from "./Privacy27Q.svelte";
  import { privacy } from "../stores.js";
</script>
<h3>※最後までご一読いただき　同意した上でお申し込みください。</h3>

{#if "23" == $privacy}
<Privacy23 />
{:else if "27Q" == $privacy}
<Privacy27Q />
{:else}
<PrivacyCommon />
{/if}
